import { IMetadata, IMetadataRequest } from "./IMetadata";

export const enum PointsTypes {
    CME = "cme",
    CPD = "cpd",
}

export const pointsTypes = [PointsTypes.CME, PointsTypes.CPD] as const;
export type IPointsTypes = (typeof pointsTypes)[number];

export interface IPointsMetadata extends IMetadata {
    pointsMetadataId: string;
    points: number;
    pointsType: IPointsTypes;
}

export interface IPointsMetadataRequest extends IMetadataRequest {
    activityInstanceIds: string[];
    pointsType?: IPointsTypes;
}

export interface IPointsMetadataDetails {
    creationDate: string;
    endDate: string;
    ownerId: string;
    ownerName: string;
    points: number;
    pointsMetadataId: string;
    startDate: string;
    pointsType: IPointsTypes;
}
